/**
 * About History 연도 탭
 * - all: 전체 표시
 * - 특정 연도: 해당 블록만 표시 (없으면 빈 상태)
 */
export function initHistoryTabs(root: ParentNode): () => void {
  const section = root.querySelector<HTMLElement>('[data-history]');
  if (!section) return () => undefined;

  const tabs = section.querySelectorAll<HTMLButtonElement>('[data-history-tab]');
  const blocks = section.querySelectorAll<HTMLElement>('[data-history-year]');

  const activate = (key: string) => {
    tabs.forEach((tab) => {
      const active = tab.dataset.historyTab === key;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    });

    blocks.forEach((block) => {
      const year = block.dataset.historyYear ?? '';
      const show = key === 'all' || year === key;
      block.hidden = !show;
    });
  };

  const onClick = (event: Event) => {
    const tab = event.currentTarget as HTMLButtonElement;
    const key = tab.dataset.historyTab;
    if (!key) return;
    activate(key);
  };

  tabs.forEach((tab) => tab.addEventListener('click', onClick));
  // 피그마 기본: 2026 활성
  activate('2026');

  return () => {
    tabs.forEach((tab) => tab.removeEventListener('click', onClick));
  };
}
